import styled from 'styled-components';

export const IconStack = styled.span`
  display: inline-grid;
  place-items: center;
  > * {
    grid-area: 1 / 1;
  }
`;
